import {React,useState} from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
 import { Card, CardContent } from '@mui/material';

export default function PropertyType() {
  const [selectedValue, setSelectedValue] = useState("residencial");

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
   
  };

  

    
    return (<>
    <div className="flex items-center justify-center px-6">
            <div className="wrapper rounded  mx-auto w-[900px]">
                <h1 className="text-[#1b1763] xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-semibold text-center py-2">
                    What type of property do you want quotes for?
                </h1>
            </div>
        </div>

        <div className="flex items-center justify-center ">
     <FormControl>
<RadioGroup
      aria-labelledby="demo-radio-buttons-group-label"
      name="radio-buttons-group"
      value={selectedValue}
      onChange={handleChange}
     
    >
      {["commercial", "residencial"].map((option) => (
        <div
          key={option}
          className={` hover:border-[#F6BC29] md:w-[500px] sm:w-[400px] w-[300px] md:my-4 my-2 md:py-4 py-2 px-6 rounded-2xl bg-white border-2 transition-all duration-300 overflow-hidden cursor-pointer ${
            selectedValue === option
              ? "border-[#F6BC29] shadow-[#F6BC29] shadow-md border-[3px] "
              : "border-gray-300 "
          }`}
          onClick={() => setSelectedValue(option)}
        >
          <FormControlLabel
            value={option}
            control={
              <Radio
                sx={{
                  color: "#475569",
                  "&.Mui-checked": { color: "#F6BC29" },
                }}
              />
            }
            label={
              <span className="text-xl text-slate-600 font-semibold" style={{ fontFamily: "'Raleway Variable', sans-serif" }}>{option.charAt(0).toUpperCase() + option.slice(1)}</span>
            }
          />
        </div>
      ))}
    </RadioGroup>
    </FormControl> 

   
        </div>
    </>
        
    );
}
